module.exports = __webpack_public_path__ + "img/ma.7fb63891.png";